import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IReminder } from '../../../interfaces/account/reminder/IReminder.ts';
import { IReminderDto, mapIReminderDtoToModel } from '../../../response/account/getMeResponse.ts';

interface IAccountReminderStates {
    items: IReminder[];
}

const initialState: IAccountReminderStates = {
    items: [],
};

export const accountRemindersSlice = createSlice({
    name: 'account-reminders',
    initialState: initialState,
    reducers: {
        updateAll: (state, action: PayloadAction<{
            favorites: IReminder[],
        }>) => {
            state.items = action.payload.favorites;
        },
        updateAllFromDTO: (state, action: PayloadAction<IReminderDto[]>) => {
            state.items = action.payload.map(value => mapIReminderDtoToModel(value));
        },
        add: (state, action: PayloadAction<IReminderDto>) => {
            const newReminder = mapIReminderDtoToModel(action.payload);
            state.items.push(newReminder);
            console.log(state.items);
        },
        delete: (state, action: PayloadAction<string>) => {
            state.items = state.items.filter((item) => item.id !== action.payload);
        },
        // removeFavorite: (state, action: PayloadAction<string>) => {
        //     state.items = state.items.filter((item) => item.id !== action.payload);
        // },
        // addFavorite: (state, action: PayloadAction<{ id: string, name: string, type: FavoriteTypeEnum }>) => {
        //     let position = 1;
        //     if (state.items.length > 0) {
        //         const sortedListDesc = state.items.sort((a, b) => b.position - a.position);
        //         position = sortedListDesc[0].position + 1;
        //     }
        //     const newFavorite: IFavorite = {
        //         name: action.payload.name,
        //         id: action.payload.id,
        //         position,
        //         type: action.payload.type,
        //         searchQuery: action.payload.name.toLowerCase(),
        //     };
        //     state.items = [...state.items, newFavorite];
        // },
    },
});

export const accountRemindersActions = accountRemindersSlice.actions;